import { Injectable, Injector } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

//--
import { InterfaceService } from '@app/interfaces';
import {BehaviorSubject, Observable} from 'rxjs';
import {FormControl} from "@angular/forms";
import {window} from "ngx-bootstrap";
import {SettingsService} from "@app/core";
declare var posthog: any;

/**
 * A structured address object for our application.
 */
export interface ParsedAddress {
    companyName: string | null;
    addressLine1: string | null;
    addressLine2: string | null;
    addressLine3: string | null;
    city: string | null;
    county: string | null;
    postcode: string | null;
    country: string | null;
}

@Injectable({
    providedIn: 'root'
})
export class CommonService extends InterfaceService {

    constructor(private http: HttpClient, private injector: Injector) {
        super();
    }

    /* Get client country code
        Response : {"countryName":"STRING<country-name>"}
    */
    getClientCountryCodes(params?: Object): Observable<any> {
        return this.http.get(this.getApiUrl(`get_client_country_code`, params));
    }
    /* Set new job phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    setNewJobPhoneCall(type: string, customerId: number, jobId: number, mode: string, data: object, params?: object){
        return this.http.post(this.getApiUrl(`customers/${type}/${customerId}/notes/jobs/${jobId}/new_phone_call/${mode}`, params), JSON.stringify(data));
    }
    /* Set new estimate phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    setNewEstimatePhoneCall(type: string, customerId: number, estimateId: number, mode: string, data: object, params?: object){
        return this.http.post(this.getApiUrl(`customers/${type}/${customerId}/notes/estimate/${estimateId}/new_phone_call/${mode}`, params), JSON.stringify(data));
    }
    /* Set new estimate phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    setNewCustomerPhoneCall(type: string, customerId: number, mode: string, data: object, params?: object){
        return this.http.post(this.getApiUrl(`${type}/new_phone_call/${customerId}/${mode}`, params), JSON.stringify(data));
    }
    /* Set new invoice phone call
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    setNewInvoicePhoneCall(type: string, customerId: number, jobId: number,invoiceId: number, mode: string, data: object, params?: object){
        return this.http.post(this.getApiUrl(`customers/${type}/${customerId}/notes/jobs/${jobId}/invoices/${invoiceId}/new_phone_call/${mode}`, params), JSON.stringify(data));
    }
    /* get infobar details from communications
       Response : {'tablepkid': number , 'noteId': number, 'success' => 'New note saved' }
    */
    getInfoBarDetails(Id: any, tableType: number): Observable<any> {
        return this.http.get(this.getApiUrl(`getInfoBarDetails?id=${Id}&type=${tableType}`));
    }
    /* get print and post credits */
    getCheckPrintPostCredits(): Observable<any>{
        return this.http.get(this.getApiUrl(`check_print_post_credits`));
    }
    /* process print and post */
    printAndPostService(type,id): Observable<any>{
        return this.http.get(this.getApiUrl(`process_printpost?tableType=${type}&tablePKID=${id}&type=print_post`));
    }

    saveUserNewUIPreference(data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`saveUserNewUIPreference`), data);
    }

    /* postcode details call*/
    getPostCodeService(postcode): Observable<any>{
        return this.http.get(this.getApiUrl(`search_postcode?postcode=${postcode}`))
    }
    /* Get county list */
    getCountiesList(): Observable<any>{
        return this.http.get(this.getApiUrl(`get_state_provinces`));
    }

    /*save county*/
    saveNewCounty(data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`save_province`),data);
    }

    /* save new landlords */
    saveNewLandlords(data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`landlord_create`),data);
    }

    /* save new workaddress */
    saveNewWorkaddress(id: number,type: string,data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`customers/${type}/${id}/work/new_works`), data);
    }

    /* Check unique county */
    checkUniqueCounty(province): Observable<any>{
        return this.http.get(this.getApiUrl(`is_province_exists?province=${province}`))
    }
    postNewInvoiceAddress(id: number,type: string,data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`customers/${type}/${id}/invoice_address_v2/new`),data)
    }

    private currentUser = new BehaviorSubject(false);
    $currentUser = this.currentUser.asObservable();

    getCurrentUser() {
        let url = this.getApiUrl(`get_current_user`);
        this.http.get(url).subscribe(result => {
            if (result) {
                this.setCurrentUser(result);
            }
        });
    }

    setCurrentUser(data:any){
        this.currentUser.next(data);
    }

    updateNewInvoiceAddress(data?: object): Observable<any> {
        return this.http.post(this.getApiUrl(`invoiceAddressUpdate`),data);
    }

    getUsersList(data : object = {}): Observable<any> {
        let url = this.getApiUrl(`get_clientUsers`, data);
        return this.http.get(url);
    }
    getClientUsersList(): Observable<any> {
        let url = this.getApiUrl(`get_client_users`);
        return this.http.get(url);
    }

    getViewersInfo(data: object) {
        return data ? {
            imageSource: data['imageSource'] || 'images/profile_avatar_small.jpg',
            name: data['name'] || null
        } : null;
    }

    /*To avoid empty spaces are allowed as valid formvalue*/
    whitespaceValidator(control: FormControl) {
        const trimmedControlValue = (control.value || '').trim();
        return trimmedControlValue == '' ? {'required': true} : null;
    };

    private mailModalCase = new BehaviorSubject(false);
    $mailModalCase = this.mailModalCase.asObservable();

    setMailModalCase(data) {
        this.mailModalCase.next(data)
    }

    getIsUserActive(id): Observable<any> {
        let url = this.getApiUrl(`getIsUserActive?userId=${id}`);
        return this.http.get(url);
    }
    getJobOnHoldDescription(): Observable<any> {
        let url = this.getApiUrl(`getJobOnHoldDescription`);
        return this.http.get(url);
    }

    postPostHogDetails(event: any, paramaters: any) {
        const settings = this.injector.get(SettingsService);
        const accountType = settings.accountType;
        if (window['posthog'] && accountType == 5) {
            posthog.capture(event, {
                paramaters
            });
        }
    }
}
